import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import PortfolioCard from './PortfolioCard';

const Portfolio = () => {
  const { t } = useLanguage();
  const p = t.portfolio;

  return (
    <section id="portfolio" className="py-20 px-5 bg-bg-black-900">
      <div className="container mx-auto max-w-6xl">
        <div className="section-title mb-16">
          <h2 className="text-4xl font-bold relative inline-block pb-3">{p.title}</h2>
        </div>

        {/* Professional Projects */}
        <div className="mb-12">
          <h2 className="text-2xl font-medium text-text-black-900 mb-10">{p.professional}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {p.proProjects.map((project, idx) => (
              <PortfolioCard key={idx} project={project} t={t} />
            ))}
          </div>
        </div>

        {/* Study Projects */}
        <div className="mb-12">
          <h2 className="text-2xl font-medium text-text-black-900 mb-10">{p.study}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {p.studyProjects.map((project, idx) => (
              <PortfolioCard key={idx} project={project} t={t} />
            ))}
          </div>
        </div>

        {/* Personal Projects */}
        <div>
          <h2 className="text-2xl font-medium text-text-black-900 mb-10">{p.personal}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {p.personalProjects.map((project, idx) => (
              <PortfolioCard key={idx} project={project} t={t} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
